module.exports = __webpack_public_path__ + "static/media/gf.699813dc.gif";